export default "__VITE_ASSET__DMxIunGc__"